export default {
  showHidden: 'Zobraziť skryté signály',
  deselectAll: 'Zrušiť výber všetkých',
  newSignal: 'Nový virtuálny signál',
};
